import { render, staticRenderFns } from "./ClinicalTrial.vue?vue&type=template&id=9076a16e&scoped=true&"
import script from "./ClinicalTrial.vue?vue&type=script&lang=js&"
export * from "./ClinicalTrial.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalTrial.vue?vue&type=style&index=0&id=9076a16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9076a16e",
  null
  
)

export default component.exports